import { render, staticRenderFns } from "./UserInviteForm.vue?vue&type=template&id=a2f42bcc"
import script from "./UserInviteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInviteForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports